import { Storage } from "@/utils/Storage";

export type ICommonState = {
  isOwner: boolean;
  currentRoute: string;
};

const state: ICommonState = {
  isOwner: false,
  currentRoute: "/home"
};

const ex = 7 * 24 * 60 * 60 * 1000; // 一周过期

const mutations = {
  setIsOwner(state: ICommonState, data: boolean) {
    state.isOwner = data;
    Storage.set("IS_OWNER", data, ex);
  },
  setCurrentRout: (state: ICommonState, data: string) => {
    state.currentRoute = data;
  }
};

export default {
  namespaced: true,
  state,
  mutations
};
